import { render } from "./programs.vue?vue&type=template&id=ae4aeff8"
import script from "./programs.vue?vue&type=script&lang=js"
export * from "./programs.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__